import { Autocomplete, FormControlLabel, InputLabel, OutlinedInput, Switch, TextField } from "@mui/material";
import { produce } from "immer";
import React from "react";
import FormSection from "../../../../../Components/Forms/FormSection/form-section";
import { setupService } from "../../../../../Core/Api/services";
import { GetPlatformInfosEnumsResponse } from "../../../../../Core/Api/Types/get-platform-infos-enums-response";
import { PlatformMode } from "../../../../../Core/Api/Types/platform-mode";
import { SectionGlobalProps } from "../settings-global";
import { useTranslation } from "react-i18next";

const SettingsGlobalSectionGlobal: React.FC<SectionGlobalProps> = (props) => {
  const { t } = useTranslation();
  const { platformInfos, setPlatformInfos } = props;
  const [platformEnums, setPlatformEnums] = React.useState<GetPlatformInfosEnumsResponse>(
    new GetPlatformInfosEnumsResponse()
  );

  const platformIsUnderSubscriptionOffer = platformInfos.billingData?.offerId ? true : false;

  React.useEffect(() => {
    setupService.GetPlatformInfosEnums().then(function (response) {
      if (response.success) setPlatformEnums(response);
    });
  }, []);

  return (
    <FormSection title={t("common:global")} status="todo" sx={{ mb: 2 }}>
      <InputLabel sx={{ mb: 1 }}>{t("common:name")}</InputLabel>
      <OutlinedInput
        value={platformInfos.name || ""}
        id={"name"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.name = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.urlBase")}</InputLabel>
      <OutlinedInput
        value={platformInfos.urlBase || ""}
        id={"urlBase"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.urlBase = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.loginSuffix")}</InputLabel>
      <OutlinedInput
        value={platformInfos.loginSuffix || ""}
        id={"loginSuffix"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.loginSuffix = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.customerExternalIdLabel")}</InputLabel>
      <OutlinedInput
        value={platformInfos.customerExternalIdLabel || ""}
        id={"customerExternalIdLabel"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.customerExternalIdLabel = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.brandLogoUrl")}</InputLabel>
      <OutlinedInput
        value={platformInfos.brandLogoUrl || ""}
        id={"brandLogoUrl"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.brandLogoUrl = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.faviconUrl")}</InputLabel>
      <OutlinedInput
        value={platformInfos.faviconUrl || ""}
        id={"faviconUrl"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.faviconUrl = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.fontName")}</InputLabel>
      <OutlinedInput
        value={platformInfos.fontName || ""}
        id={"fontName"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.fontName = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("common:licences")}</InputLabel>
      <Autocomplete
        value={platformInfos.licences || []}
        multiple
        onChange={(e, value) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.licences = value;
            })
          )
        }
        options={platformEnums.licences || []}
        sx={{ width: "100%", mb: 2 }}
        id={"licenses"}
        renderInput={(params) => <TextField sx={{ mt: "-24px" }} {...params} />}
        disabled={platformIsUnderSubscriptionOffer}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.erpApiLogin")}</InputLabel>
      <OutlinedInput
        value={platformInfos.erpApiLogin || ""}
        id={"erpApiLogin"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.erpApiLogin = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.erpApiPassword")}</InputLabel>
      <OutlinedInput
        value={platformInfos.erpApiPassword || ""}
        id={"erpApiPassword"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.erpApiPassword = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.kafkaServerUrl")}</InputLabel>
      <OutlinedInput
        value={platformInfos.kafkaServerUrl || ""}
        id={"kafkaServerUrl"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.kafkaServerUrl = e.currentTarget.value;
            })
          )
        }
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.authenticationMode")}</InputLabel>
      <Autocomplete
        value={platformInfos.authMode}
        onChange={(e, value) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.authMode = value;
            })
          )
        }
        options={platformEnums.authModes || []}
        sx={{ width: "100%", mb: 2 }}
        id={"authenticationMode"}
        renderInput={(params) => <TextField sx={{ mt: "-24px" }} {...params} />}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.mainUsageMode")}</InputLabel>
      <Autocomplete
        value={platformInfos.mode}
        onChange={(e, value) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.mode = value;
            })
          )
        }
        options={Object.values(PlatformMode)}
        sx={{ width: "100%", mb: 2 }}
        id={"mode"}
        renderInput={(params) => <TextField sx={{ mt: "-24px" }} {...params} />}
      />
      <InputLabel sx={{ mb: 1 }}>{t("field:label.catchPhrase")}</InputLabel>
      <OutlinedInput
        value={platformInfos.catchPhrase || ""}
        id={"catchPhrase"}
        sx={{ width: "100%", mb: 2 }}
        onChange={(e) =>
          setPlatformInfos(
            produce((draft) => {
              draft!.catchPhrase = e.target.value;
            })
          )
        }
      />
      <FormControlLabel
        sx={{ mt: 1, ml: 0 }}
        control={
          <Switch
            size="small"
            checked={platformInfos.cof}
            onChange={(e) => {
              setPlatformInfos(
                produce((draft) => {
                  draft!.cof = e.target.checked;
                })
              );
            }}
          />
        }
        label={t("field:label.approveGeneralConditionsOfUse")}
      />
      <FormControlLabel
        sx={{ mt: 1, ml: 0 }}
        control={
          <Switch
            size="small"
            checked={platformInfos.wowzaUseHlsChunker}
            onChange={(e) => {
              setPlatformInfos(
                produce((draft) => {
                  draft!.wowzaUseHlsChunker = e.target.checked;
                })
              );
            }}
          />
        }
        label={t("field:label.enableShareLiveBurn")}
      />
      <FormControlLabel
        sx={{ mt: 1, ml: 0 }}
        control={
          <Switch
            size="small"
            checked={platformInfos.allowPlayRawAsRefIfNotMezzFound}
            onChange={(e) => {
              setPlatformInfos(
                produce((draft) => {
                  draft!.allowPlayRawAsRefIfNotMezzFound = e.target.checked;
                })
              );
            }}
          />
        }
        label={t("field:label.allowPlayRawAsRefIfNotMezzFound")}
      />
      <FormControlLabel
        sx={{ mt: 1, ml: 0 }}
        control={
          <Switch
            size="small"
            checked={platformInfos.showUnassignedKdmRecipients ?? false}
            onChange={(e) => {
              setPlatformInfos(
                produce((draft) => {
                  draft!.showUnassignedKdmRecipients = e.target.checked;
                })
              );
            }}
          />
        }
        label={t("field:label.showUnassignedKdmRecipients")}
      />
    </FormSection>
  );
};

export default SettingsGlobalSectionGlobal;
